module.exports = __webpack_public_path__ + "img/smw-library-responsive.59956824.jpg";